module.exports = __webpack_public_path__ + "media/custom/images/footer-logo-85c0ce62847233bd5923fcf8a2233322.png";